module.exports = __webpack_public_path__ + "static/fun-time/games/page002_game0/audio//3_Tom.mp3";